<template>
  <div class="plc-loader" :class="{ 'plc-loader--center': isCentered }">
    <loader :height="height" :width="width" class="plc-loader__svg" />
  </div>
</template>

<script>
import Loader from '@/assets/img/loader.svg?inline'

export default {
  name: 'GlLoader',
  components: {
    Loader,
  },
  props: {
    isCentered: Boolean,
    text: {
      type: String,
      default: '',
    },
    height: {
      type: String,
      required: false,
      default: '70',
    },
    width: {
      type: String,
      required: false,
      default: '70',
    },
  },
}
</script>

<style lang="scss" scoped>
.plc-loader {
  padding: 40px;
  text-align: center;

  &__svg {
    @include loader;
  }

  &--center {
    margin: auto;
  }
}
</style>
